"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.logger = exports.setForwardErrorsToServer = exports.activateLogging = void 0;
// it is too dangerous to log in production. And this can happen. I'm putting this safety so we prevent this to happen.
var isLoggingEnabled = process && process.env && process.env.ENV && process.env.ENV.includes('prod');
var forwardErrorToServer;
var colors = {};
var getColor = function (key) {
    if (colors[key]) {
        return colors[key];
    }
    var keyValue = 1 / Array.from(key).reduce(function (acc, _, index) { return acc + key.charCodeAt(index); }, 4224);
    var thisColor = "#".concat(Math.floor(keyValue * 16777215).toString(16));
    colors[key] = thisColor;
    return thisColor;
};
var isError = function (method) { return method === 'error'; };
var log = function (method) { return function (functionName, text, object) {
    if (isLoggingEnabled) {
        var timeNow = +new Date();
        return console[method]("%c".concat(timeNow, ":%c").concat(functionName, " %c- ").concat(text), "color: green; font-weight: bold;", "color: ".concat(getColor(functionName), "; font-weight: bold; text-decoration: underline"), 'font-weight: bold;', object !== undefined ? object : '', (object && object.stack) || '');
    }
    return undefined;
}; };
var execute = function (method) { return log(method); };
var executeWithExtraInfo = function (method, position, group) {
    var scopedLogger = log(method);
    return function (text, object) {
        return scopedLogger(position, group ? "".concat(group, " - ").concat(text) : text, object);
    };
};
var activateLogging = function (value) {
    isLoggingEnabled = value;
};
exports.activateLogging = activateLogging;
var setForwardErrorsToServer = function (value) {
    forwardErrorToServer = value;
};
exports.setForwardErrorsToServer = setForwardErrorsToServer;
exports.logger = {
    log: execute('log'),
    error: execute('error'),
    info: execute('info'),
    warn: execute('warn'),
    loggerIn: function (position) { return ({
        log: executeWithExtraInfo('log', position),
        error: executeWithExtraInfo('error', position),
        info: executeWithExtraInfo('info', position),
        warn: executeWithExtraInfo('warn', position),
        // group logging
        groupIn: function (group) { return ({
            log: executeWithExtraInfo('log', position, group),
            error: executeWithExtraInfo('error', position, group),
            info: executeWithExtraInfo('info', position, group),
            warn: executeWithExtraInfo('warn', position, group),
        }); },
    }); },
};
if (typeof window !== 'undefined') {
    window.logger = {
        activateLogging: exports.activateLogging,
    };
}
exports.default = exports.logger;
//# sourceMappingURL=index.js.map